module.exports = __webpack_public_path__ + "assets/4daf47785b551bd68f27c6f5b8b4a7ff.mp3";